export default __webpack_public_path__ + "static/media/Wadhwani.a7713c31.jpg";